import { render, staticRenderFns } from "./parties.vue?vue&type=template&id=5c3dd6da&scoped=true&"
import script from "./parties.vue?vue&type=script&lang=js&"
export * from "./parties.vue?vue&type=script&lang=js&"
import style0 from "./parties.vue?vue&type=style&index=0&id=5c3dd6da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3dd6da",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VDivider,VForm,VIcon,VSpacer,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src327451746/src/bitbucket.org/iprosystems/customer-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3dd6da')) {
      api.createRecord('5c3dd6da', component.options)
    } else {
      api.reload('5c3dd6da', component.options)
    }
    module.hot.accept("./parties.vue?vue&type=template&id=5c3dd6da&scoped=true&", function () {
      api.rerender('5c3dd6da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parties.vue"
export default component.exports